var Time = function (val) {
	this.__construct(val);
}

jQuery.extend(Time.prototype, {

	seconds: 0,
	minutes: 0,
	hours: 0,

	__construct: function (val) {
		if (val instanceof Time) {
			this.seconds = val.getSeconds();
			this.minutes = val.getMinutes();
			this.hours = val.getHours();
		}
		if (jQuery.type(val) == 'string') {
			this.parseFromString(val);
		}
		if (jQuery.type(val) == 'number') {
			this.parseFromInteger(val);
		}
		if (jQuery.type(val) == 'date') {
			this.parseFromDate(val);
		}
	},

	parseFromString: function (val) {
		val = val.toUpperCase();
		var addHour = 0;
		if (val.search('PM') != -1) {
			addHour = 12;
		}
		val = val.replace('PM', '').replace('AM', '');
		val = val.split(':');

		this.hours = parseInt(val[0], 10) + addHour;
		this.minutes = parseInt(val[1], 10);
	},

	parseFromInteger: function (val) {
		this.hours = Math.floor(val / 60);
		this.minutes = (val - this.hours * 60);
	},

	parseFromDate: function (val) {
		this.hours = val.getHours();
		this.minutes = val.getMinutes();
	},

	getHours: function () {
		return this.hours;
	},

	getMinutes: function () {
		return this.minutes;
	},

	getSeconds: function () {
		return this.seconds;
	},

	getInteger: function () {
		return (this.hours * 60) + this.minutes;
	},

	getFormattedTime: function (format) {
		// debugger
		var frmt = this._getFormat(format);

		if (frmt == '24hr') { 
			return this._fixZero(this.getHours()) + ':' + this._fixZero(this.getMinutes());
		} else if (format == 'hours' || format == 'hours_24hr' || (format == 'hours_auto' && this._getFormat() == '24hr')) {
			return this._fixZero(this.getHours());
		}

		var pref = 'AM';
		var hours = this.getHours() % 24;
		if (hours >= 12) {
			if (hours > 12) {
				hours = hours - 12;
			}
			pref = 'PM';
		}
		if (hours == 0) {
			hours = 12;
		}

		if (format == 'hours_auto' || frmt == 'hours_ampm') {
			return hours + ' ' + pref;
		}

		return hours + ':' + this._fixZero(this.getMinutes()) + ' ' + pref;
	},

	getMysqlTime: function () {
		return this._fixZero(this.getHours()) + ':' + this._fixZero(this.getMinutes()) + ':' + this._fixZero(this.getSeconds());
	},

	getDuration: function () {
		var result = [];
		if (this.hours > 0) {
			result.push(
				this.hours + ' ' + this._getDurationText(this.hours, 'hour')
			);
		}
		if (this.minutes > 0) {
			result.push(
				this.minutes + ' ' + this._getDurationText(this.minutes, 'minute')
			);
		}
		return result.join(', ');
	},

	_getDurationText: function (value, type) {
		var value = value.toString();
        var text = '';
        if (value == '12' || value == '13' || value == '14') {
        	text = (type == 'hour' ? 'many_hours_key' : 'minutes');
        } else {
        	value = value.slice(value.length - 1, value.length);
        	if (value == '1') {
        		text = (type == 'hour' ? 'hour' : 'minute');
       		} else if (value == '2' || value == '3' || value == '4') {
        		text = (type == 'hour' ? '2_3_4_hour_key' : '2_3_4_minute_key');
       		} else {
       			text = (type == 'hour' ? 'many_hours_key' : 'minutes');
       		}
       	}
        return Locale.get(text);
	},

	_fixZero: function (val) {
		if (val <= 9) {
			return '0' + val;
		}
		return val;
	},

	_getFormat: function (format) {
		if (jQuery.type(format) === 'undefined') {
			if (jQuery.type(Config) !== 'undefined') {
				format = Config.getTimeFormat();
			} else {
				format = '24hr';
			}
		}
		return format;
	}

});

Time.parseFromInteger = function(value) {
	var t = new Time();
	t.parseFromInteger(value);
	return t;
};
define("utils.time", ["jquery","utils.locale"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Time;
    };
}(this)));

